module.exports = __webpack_public_path__ + "static/media/example-recipients.0a57950c.csv";